import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface ExtraIdState {
  extraIdFrom: string;
  extraIdTo: string;
}

const initialState: ExtraIdState = {
  extraIdFrom: "",
  extraIdTo: "",
};

export const ExtraIdSlice = createSlice({
  name: "ExtraIdSlice",
  initialState,
  reducers: {
    setExtraIdFromData: (state, action: PayloadAction<string>) => {
      state.extraIdFrom = action.payload;
    },
    setExtraIdToData: (state, action: PayloadAction<string>) => {
      state.extraIdTo = action.payload;
    },
  },
});

export const { setExtraIdFromData, setExtraIdToData } = ExtraIdSlice.actions;

export default ExtraIdSlice.reducer;
